// src/EtiquetasEnvio.js
import React, { useState, useEffect } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import apinode from '../../services/apinode'
import Swal from 'sweetalert2'
import { now } from 'moment/moment'

function EtiquetasEnvio() {
  const [selectedDate, setSelectedDate] = useState(null)
  const [selectedAccount, setSelectedAccount] = useState('Conta 1') // Conta padrão
  const [etiquetas, setEtiquetas] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [storeOptions, setStoreOptions] = useState([])
  const [selectedStore, setSelectedStore] = useState('')

  const handleDateChange = (date) => {
    setSelectedDate(date)
  }

  useEffect(() => {
    // Função para buscar as opções de lojas da API
    const fetchStoreOptions = async () => {
      try {
        console.log('Fetching store options...')
        const response = await apinode.get(`/api/lojas/${localStorage.idconta}`)
        console.log('Store options response:', response.data)
        setStoreOptions(response.data)
        if (response.data.length > 0) {
          setSelectedStore(response.data[0].ID_CONTA) // Seleciona o ID da primeira opção por padrão
        }
        setIsLoading(false) // Marca o carregamento como concluído
      } catch (error) {
        console.error('Erro ao buscar opções de lojas:', error)
        setIsLoading(false) // Marca o carregamento como concluído em caso de erro
      }
    }

    fetchStoreOptions() // Chama a função de busca quando o componente for montado
  }, []) // O array vazio como segundo argumento garante que a função seja executada apenas uma vez, no montagem do componente

  const fetchStoreOptions = async () => {
    try {
      console.log('Fetching store options...')
      const response = await apinode.get(`/api/lojas/${localStorage.idconta}`)
      console.log('Store options response:', response.data)
      setStoreOptions(response.data)
      if (response.data.length > 0) {
        setSelectedStore(response.data[0].ID_CONTA) // Seleciona o ID da primeira opção por padrão
        console.log(selectedStore)
      }
    } catch (error) {
      console.error('Erro ao buscar opções de lojas:', error)
    }
  }

  const handleSelectChange = (event) => {
    setSelectedStore(event.target.value)
    console.log(event.target.value)
    // Faça o que for necessário com o valor selecionado, como atualizar o estado
  }

  async function fetchLabels(data, conta) {
    try {
      const response = await apinode.get(
        `/labels/${data}/${conta}/${localStorage.idconta}`,
      )
      console.log(response)
      return response.data
    } catch (error) {
      console.error('Erro ao buscar etiquetas:', error)
      throw error
    }
  }

  // Formata a data no formato "DD.MM.YY"

  useEffect(() => {
    const fetchStoreOptions = async () => {
      try {
        console.log('Fetching store options...')
        const response = await apinode.get(`/api/lojas/${localStorage.idconta}`)
        console.log('Store options response:', response.data)
        setStoreOptions(response.data)
        if (response.data.length > 0) {
          setSelectedStore(response.data[0].ID_CONTA) // Seleciona o ID da primeira opção por padrão
        }
        setIsLoading(false) // Marca o carregamento como concluído
      } catch (error) {
        console.error('Erro ao buscar opções de lojas:', error)
        setIsLoading(false) // Marca o carregamento como concluído em caso de erro
      }
    }

    fetchStoreOptions() // Chama a função de busca quando o componente for montado

    const data = new Date()
    const dia = String(data.getDate()).padStart(2, '0') // Obtém o dia e adiciona zero à esquerda, se necessário
    const mes = String(data.getMonth() + 1).padStart(2, '0') // Obtém o mês (lembre-se que os meses começam de 0) e adiciona zero à esquerda, se necessário
    const ano = data.getFullYear() // Obtém o ano

    const dataFormatada = `${dia}.${mes}.${ano}`
    setSelectedDate(new Date())

    console.log(dataFormatada) // Isso imprimirá a data no formato "DD.MM.YYYY"

    const conta = selectedStore // Substitua com a conta desejada

    // Chame a função fetchLabels para buscar etiquetas
    fetchLabels(dataFormatada, conta)
      .then((data) => {
        setEtiquetas(data)
        setIsLoading(false)
        console.log(data)
      })
      .catch((error) => {
        console.error('Erro ao buscar etiquetas:', error)
        setIsLoading(false)
      })
  }, [])

  const handleSearchButtonClick = () => {
    if (!selectedStore) {
      // Verifica se o dropdown não tem um valor selecionado
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Por favor, selecione uma conta.',
      })
    } else if (!selectedDate) {
      // Verifica se a data não foi selecionada
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        text: 'Por favor, selecione uma data.',
      })
    } else {
      const data = selectedDate
      const dataFormatada = data
        .toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
        .replace(/\//g, '.')

      const conta = selectedStore // Substitua com a conta desejada

      // Chame a função fetchLabels para buscar etiquetas
      fetchLabels(dataFormatada, conta)
        .then((data) => {
          setEtiquetas(data)
          setIsLoading(false)
          console.log(data)
        })
        .catch((error) => {
          console.error('Erro ao buscar etiquetas:', error)
          setIsLoading(false)
        })
    }
  }

  // const handleAccountChange = (event) => {
  //     setSelectedAccount(event.target.value);
  // };

  const handleCheckboxChange = (index) => {
    const newEtiquetas = [...etiquetas]
    newEtiquetas[index].selecionado = !newEtiquetas[index].selecionado
    setEtiquetas(newEtiquetas)
  }

  const imprimirEtiquetasSelecionadas = () => {
    const etiquetasSelecionadas = etiquetas.filter(
      (etiqueta) => etiqueta.selecionado,
    )
    // Lógica para imprimir etiquetas selecionadas
  }

  return (
    <div className="container">
      <h1>Impressão de Etiquetas de Envio</h1>

      <div className="card">
        <div className="card-body">
          <div className="row align-items-center">
            <div className="col-md-3 mb-2">
              <label htmlFor="accountDropdown">Conta:</label>
              <select
                id="accountDropdown"
                className="form-control custom-dropdown"
                value={selectedStore}
                onChange={handleSelectChange}
              >
                {storeOptions.map((store) => (
                  <option
                    key={store.ID_CONTA}
                    value={store.ID_CONTA}
                  >
                    {store.APELIDO}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-4 mb-2">
              <div className="form-group d-flex flex-column">
                <label htmlFor="datePicker">Data:</label>
                <DatePicker
                  id="datePicker"
                  selected={selectedDate}
                  onChange={handleDateChange}
                  className="form-control"
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Selecione uma data"
                />
              </div>
            </div>

            <div className="col-md-3 mb-2 align-self-end">
              <button
                className="btn btn-primary"
                onClick={handleSearchButtonClick}
              >
                Pesquisar
              </button>
            </div>
          </div>
        </div>
      </div>

      {isLoading ? (
        <p>Carregando...</p>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Cliente</th>
              <th>Número do Pedido</th>
              <th>Status da Impressão</th>
              <th>Seleção</th>
            </tr>
          </thead>
          <tbody>
            {etiquetas.map((etiqueta, index) => (
              <tr key={index}>
                <td>
                  <span className="badge bg-primary">{etiqueta.ORDERID}</span>
                  <br />
                  <span className="badge bg-secondary">{etiqueta.SHIPID}</span>
                </td>
                <td>{etiqueta.CLIENTE}</td>
                <td>{etiqueta.NUMEROPEDIDO}</td>
                <td>{etiqueta.STATUSIMPRESSAO}</td>
                <td>
                  <input
                    type="checkbox"
                    checked={etiqueta.selecionado}
                    onChange={() => handleCheckboxChange(index)}
                  />
                </td>
              </tr>
            ))}
          </tbody>

          {}
        </table>
      )}
      {etiquetas.length == 0 ? (
        <div className="no-item">Nenhuma etiqueta disponível</div>
      ) : null}

      <button
        className="btn btn-primary"
        onClick={imprimirEtiquetasSelecionadas}
      >
        Imprimir Etiquetas Selecionadas
      </button>
    </div>
  )
}

export default EtiquetasEnvio
